import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState: Array<string> = [];

interface EventStatusResponse {
	status: Array<string>;
}

export const { thunk: fetchEventStatuses, slice: eventStatusSlice } = getThunkAndSlice<
	Record<string, never>,
	EventStatusResponse,
	Array<string>
>({
	initialState,
	path: "/api/events/filter/status",
	onAfterRequest: async (data: EventStatusResponse | Array<string>) => {
		if (Array.isArray(data)) return data;
		return data.status ?? [];
	},
});

export default eventStatusSlice.reducer;
